import React from 'react';
import { InputField, PasswordField } from '../../../utility/form';
import LoadingButton from '../../../utility/button/LoadingButton';
import useLogin from './useLogin';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Login = () => {
  const { t } = useTranslation();
  const { form, onChange, onSubmit, loading, validate, result, errors } = useLogin();
  const navigate = useNavigate();

  return (
    <div className="auth-card mx-auto">
      <h3 className="text-center fw-bold mb-1">{t('login.title')}</h3>
      <div className="text-center" style={{ color: '#7b7b8b', fontSize: '1rem', marginBottom: 20 }}>
        {t('login.subtitle')}
      </div>
      <div className="d-flex justify-content-center align-items-center mb-4" style={{ borderBottom: '1px solid #ccc' }}>
        <div className="tab-active px-4 py-2" style={{ cursor: 'pointer' }}>{t('login.signInTab')}</div>
        <div className="tab-inactive px-4 py-2" style={{ cursor: 'pointer' }} onClick={() => navigate('/signup')}>
          {t('login.signUpTab')}
        </div>
      </div>

      <form onSubmit={onSubmit} noValidate>
        <div className="mb-3">
          <InputField
            label={t('login.emailLabel')}
            name="email"
            value={form.email}
            onChange={onChange}
            error={errors.email}
            placeholder={t('login.emailPlaceholder')}
            type="email"
          />
        </div>
        <div className="mb-1">
          <PasswordField
            label={t('login.passwordLabel')}
            name="password"
            value={form.password}
            onChange={onChange}
            error={errors.password}
            placeholder={t('login.passwordPlaceholder')}
            type="password"
          />
        </div>

        <div className="d-flex justify-content-end mb-3">
          <Link className="btn-link p-0 signin-section-link" style={{
            pointerEvents: 'auto',
            cursor:'pointer',
          }} to="/forgot-password">{t('login.forgotPassword')}</Link>
        </div>
        <LoadingButton
            type="submit"
            disabled={loading}
            isLoading={loading}
            className="w-100 mb-2"
          >
          {t('login.submit')}
        </LoadingButton>
      </form>
      <hr />
      <a className="btn w-100 mb-3 recive-btn" href="/unlock-account">Didn't receive unlock instructions?</a>
      {/*<div className="card-sep text-center">Or</div>
      <button className="btn w-100 mb-2 bg-white border d-flex align-items-center justify-content-center" type="button">
        <img src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg" alt="Google" style={{ width: 22, marginRight: 10 }} /> Sign In With Google
      </button>
      <button className="btn w-100 bg-white border d-flex align-items-center justify-content-center" type="button">
        <img src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg" alt="Amazon" style={{ width: 24, marginRight: 7 }} /> Sign In With Amazon
      </button>*/}
    </div>
  );
};

export default Login;
